// src/component/Loader.js
import React, { useEffect, useState } from 'react';
import './css/Loader.css'; // Import the CSS for the loader
import imageUrl from './images/7.png'; // Correctly import the image

const Loader = () => {
  const [opacity, setOpacity] = useState(0.2);

  useEffect(() => {
    const fadeEffect = setTimeout(() => setOpacity(1), 1500); // Fade effect lasts 3 seconds

    return () => clearTimeout(fadeEffect);
  }, []);

  return (
    <div className="loader">
      <img src={imageUrl} alt="Loading" style={{ opacity, transition: 'opacity 1.5s', width: '350px' }} />
      {/* From Uiverse.io by satyamchaudharydev 
      {<div class="loader-progress"></div>
      <p>Loading...</p>*/ }

      <div className="tm-container">
        <div className="tm-box black"></div>
        <div className="tm-box white"></div>
        <div className="tm-box black"></div>
        <div className="tm-box white"></div>
        <div className="tm-box white"></div>
      </div>
    </div>
  );
};

export default Loader;
